module.exports = __webpack_public_path__ + "static/media/group.95a5abc6.svg";